import styled, { css } from "styled-components"
import Breakpoints from "../shared/breakpoints"
import TextStyles from "../shared/typography.styles"
import { T } from "../shared/typography.styles"
import ContactFormLink from "../shared/contact-form-link"

export const FeatureTitle = styled.h3`
  color: var(--slate);
  ${T.sm.h3.bold}
  grid-column: 1 / -1;
  margin-top: 32px;

  @media (min-width: ${Breakpoints.md}) {
    ${T.md.h3.bold}
    text-align: center;
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.h3.bold}
    text-align: left;
    margin-top: 0px;
  }

  ${(props) => props.styleModifier}
`

export const Container = styled.div`
  margin: 64px 0;

  @media (min-width: ${Breakpoints.lg}) {
    margin: 128px 0;
  }
`

export const Spacer = styled.div`
  grid-column: 1 / -1;
  width: 100%;
  margin-top: 64px;

  @media (min-width: ${Breakpoints.md}) {
    margin-top: 96px;
  }

  @media (min-width: ${Breakpoints.lg}) {
    margin-top: 120px;
  }
`

export const ProjectRow = styled.div`
  grid-column: 1 / -1;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 0 40px;

  & > * {
    margin: 0 5vw;
  }
`

export const ImageContainer = styled.div`
  overflow: hidden;
  align-self: center;
  & > * {
    max-width: 100%;
    max-height: 100%;
  }
  ${(props) => props.styles}
`

export const CopyText = styled.p`
  ${TextStyles.desktopTextStyles.BodyText16}
  padding-top: 32px;
  & > em {
    font-weight: 500;
  }
  text-align: left;

  @media (min-width: ${Breakpoints.md}) {
    padding-top: 24px;
    text-align: center;
  }

  @media (min-width: ${Breakpoints.lg}) {
    ${TextStyles.desktopTextStyles.BodyText18}
    padding-top: 32px;
    text-align: left;
  }

  ${(props) => props.styleModifier}
`

export const buttonStyle = css`
  grid-row: 8;
  
  @media (min-width: ${Breakpoints.md}) {
    grid-row: 7;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 8 / 10;
    grid-row: 5;
  }
`

export const LinkContainer = styled(ContactFormLink)`
  cursor: pointer;
  max-width: 282px;
  width: 282px;
  margin-top: 32px;

  @media (min-width: ${Breakpoints.md}) {
    display: flex;
    align-items: center;
    text-align: center;
    justify-self: flex-start;
    justify-self: center;
    margin-left: auto;
    margin-right: auto;
  }

  @media (min-width: ${Breakpoints.lg}) {
    justify-self: flex-start;
    grid-row: 5;
    margin-top: 16px;
  }
`

export const VideoProgressContainer = styled.div`
  grid-column: 2 / -2;
  align-self: center;
  width: 100%;
  display: grid;

  grid-column-gap: 48px;
  grid-row-gap: 32px;

  & p {
    color: var(--slate) !important;
  }
  margin-top: 48px;
  grid-row: 3;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 8 / -2;
    grid-row: 2;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 7 / -2;
    align-self: start;
    margin-top: 48px;
    grid-template-columns: 1fr 1fr;
  }
`

/*Project Responsive Positioning */

export const featuresImageStyle = css`
  grid-column: 3 / -3;
  grid-row: 2;
  margin-top: 48px;
  height: 501px;
  width: 282px;
  justify-self: center;
  align-self: center;

  overflow: hidden;
  border-radius: 8px;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / 7;
    margin-top: 48px;
    height: calc(35.6vw * 1.7777);
    width: 35.6vw;
    max-width: 315px;
    max-height: 560px;
    border-radius: 15px;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 2 / 6;
    grid-row: 1 / 3;

    width: 29.9vw;
    height: calc(29.9vw * 1.7777);

    max-width: 461px;
    max-height: 820px;
  }

  & > * {
    width: 100% !important;
    height: 100% !important;
  }
`
export const featuresBodyStyle = css`
  display: grid;
  grid-column: 1 / -1;
  margin-top: 0px;
  grid-row: 1;
  justify-items: start;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -2;
    justify-items: center;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: -7 / -2;
    margin-left: 0px;
    justify-items: start;
  }
`
export const adContentImageStyle = css`
  grid-column: 2 / -2;
  margin-bottom: 32px;
  margin-top: 32px;
  grid-row: 5;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 4 / -4;
    margin-top: 48px;
    grid-row: 4;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 8 / -1;
    grid-row: 3;
    margin-top: 96px;
  }
`

export const adContentBodyStyle = css`
  grid-column: 1 / -1;
  text-align: left;
  grid-row: 4;
  margin-top: 16px;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -2;
    text-align: center;
    grid-row: 3;
    margin-top: 64px;
  }
  @media (min-width: ${Breakpoints.lg}) {
    margin-top: 0px;
    grid-column: 2 / 7;
    text-align: center;
  }
`

export const insightsImageStyle = css`
  grid-column: 1 / -1;
  grid-row: 7;
  margin-top: 42px;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 3 / 11;
    grid-row: 6;
    margin-bottom: 48px;
    margin-top: 64px;
  }
  
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 1 / 7;
    grid-row: 4 / 6;
    margin-top: 120px;
  }
`
export const insightsBodyStyle = css`
  grid-column: 1 / -1;
  grid-row: 6;

  @media (min-width: ${Breakpoints.md}) {
    justify-content: center;
    text-align: center;
    grid-column: 2 / -2;
    grid-row: 5;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 8 / -1;
    text-align: left;
    grid-row: 4;
    margin-top: 120px;
  }
`
